// extracted by mini-css-extract-plugin
export default {"red":"ContractsVehicule_red__LNoTs","strong":"ContractsVehicule_strong__mgBF6","table":"ContractsVehicule_table__cMydL","toggle":"ContractsVehicule_toggle__yz3qh"};